/**
 * Created by Ning Jiang on 11/17/2016.
 */


import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require("pixi-spine");

import {gsap} from "gsap";
import {CustomEase} from "gsap/dist/CustomEase";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
gsap.registerPlugin(CustomEase, CustomWiggle);


import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {KeypadButtonIDs, SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {Outsourced} from "./game/Outsourced";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {OutsourcedIntroConfig} from "./game/intro/OutsourcedIntroConfig";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {OutsourcedPromoPanelConfig} from "./game/config/OutsourcedPromoPanelConfig";

declare global {
    interface Window {
        NolimitLauncher:NolimitLauncher;
    }
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new Outsourced(),
    new SlotKeypad({playKeypadButtonSound(id: KeypadButtonIDs | string): boolean {
            if (id == "nolimitBonusMenu") {
                Outsourced.soundPlayer.playSound("xBetOnOff");
                return false;
            } else {
                return true;
            }
        }}),
    new NolimitGameIntroPlugin(new OutsourcedIntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new OutsourcedPromoPanelConfig())
]);
